<div class="container w-100" fxFlex="100" fxLayout="row wrap" fxLayoutAlign="start center">
  <mat-form-field fxFlex="100">
    <mat-label>Accessory Bundle <small matTooltip="{{bundlesForHome.length}} Accessory Bundle(s) available">({{bundlesForHome.length}})</small></mat-label>
    <input type="text" matInput [formControl]="bundleControl" [matAutocomplete]="bundleAuto">
    <mat-autocomplete #bundleAuto="matAutocomplete" [displayWith]="displayBundle">
      <mat-option *ngFor="let bundle of filteredBundles | async" [value]="bundle">
        <div [innerHtml]="bundle.name | encodeHtml | highlight: bundleControl.value"></div>
      </mat-option>
    </mat-autocomplete>
    <button *ngIf="bundleControl?.value" matSuffix mat-icon-button color="basic" matTooltip="Clear accessory bundle" (click)="clearBundle()">
      <mat-icon>clear</mat-icon>
    </button>
  </mat-form-field>

  <div *ngIf="selectedBundle?.items?.length > 0" class="m-b-20" fxFlex="100">
    <mat-chip-list #accessoryChipList>
      <mat-chip color="accent" *ngFor="let item of selectedBundle.items" [matTooltip]="item.homeIfcFileName">
        <span>{{ item.code }}</span>
      </mat-chip>
    </mat-chip-list>
  </div>
</div>
